// src/components/common/AnnouncementBanner.jsx
import { useState } from 'react'
import { X } from 'lucide-react'
import { announcementsApi } from '@/api/services'

const styleMap = {
  info:    'bg-blue-50  text-blue-800  border-blue-200',
  warning: 'bg-yellow-50 text-yellow-800 border-yellow-200',
  success: 'bg-green-50 text-green-800 border-green-200',
  danger:  'bg-red-50   text-red-800   border-red-200',
}

export default function AnnouncementBanner({ announcements = [] }) {
  const [dismissed, setDismissed] = useState([])

  const handleDismiss = async (id) => {
    setDismissed(prev => [...prev, id])
    try { await announcementsApi.dismiss(id) } catch { /* silent */ }
  }

  const visible = announcements.filter(a => !dismissed.includes(a.id))
  if (!visible.length) return null

  return (
    <div className="space-y-0">
      {visible.map(a => (
        <div key={a.id} className={`flex items-center justify-between px-5 py-2.5 border-b text-sm font-medium ${styleMap[a.style] || styleMap.info}`}>
          <span>
            {a.link_url ? <a href={a.link_url} className="underline underline-offset-2">{a.body}</a> : a.body}
          </span>
          {a.is_dismissible && (
            <button onClick={() => handleDismiss(a.id)} className="ml-4 flex-shrink-0 hover:opacity-70">
              <X size={15} />
            </button>
          )}
        </div>
      ))}
    </div>
  )
}
